import { MainDashBoardChart } from "@/enums/MainDashBoardChart";
import { FinancialStatementItem } from "@/models/accounting/ReportItem";
import React, { createContext, ReactNode, useContext, useEffect, useState } from "react";
import { useRightDrawer } from "./RightDrawerContext";

interface SelectedChartContextType {
  selectedChart: MainDashBoardChart | null;
  selectedStatementItem: FinancialStatementItem | null;
  setSelectedStatementItem: React.Dispatch<React.SetStateAction<FinancialStatementItem | null>>;
  setSelectedChart: React.Dispatch<React.SetStateAction<MainDashBoardChart | null>>;
}

const selectedChartContext = createContext<SelectedChartContextType | undefined>(undefined);

interface selectedChartProviderProps {
  children: ReactNode;
}

export const SelectedChartProvider: React.FC<selectedChartProviderProps> = ({ children }) => {
  const { setIsOpen, isOpen } = useRightDrawer();

  const [selectedChart, setSelectedChartState] = useState<MainDashBoardChart | null>(null);

  const [selectedStatementItem, setSelectedStatementItemState] = useState<FinancialStatementItem | null>(null);

  const setSelectedChart = (c: MainDashBoardChart | null) => {
    setSelectedChartState(c);
    if (c) setIsOpen(true);
  };

  const setSelectedStatementItem = (c: FinancialStatementItem | null) => {
    setSelectedStatementItemState(c);
    if (c) setIsOpen(true);
  };

  useEffect(() => {
    if (!isOpen) {
      setSelectedChartState(null);
      setSelectedStatementItemState(null);
    }
  }, [isOpen]);

  const contextValue: SelectedChartContextType = {
    selectedStatementItem,
    selectedChart,
    setSelectedStatementItem,
    setSelectedChart,
  };

  return <selectedChartContext.Provider value={contextValue}>{children}</selectedChartContext.Provider>;
};

export const useSelectedChart = (): SelectedChartContextType => {
  const context = useContext(selectedChartContext);

  // if (!context) {
  //   throw new Error(
  //     "useSelectedChart must be used within a selectedChartProvider",
  //   );
  // }

  if (!context) {
    return {
      selectedStatementItem: null,
      setSelectedStatementItem: () => null,
      selectedChart: null,
      setSelectedChart: () => null,
    };
  }

  return context!;
};
